<template>
    <div class="wxl-list-item" :style="{'background':background}" @click.stop="clickitem()" @dblclick="$emit('dblclick')">
        <a />
        <span class="text" :style="getcontentstyle()">
            <span :style="{add:showadd==true,minus:showminus==true}" v-html="getText" />
            <slot />
        </span>
        <span v-if="showrightarrow" class="sinour normal el-icon-arrow-right" />
        <span v-if="showguanbi" class="sinour normal el-icon-close" style="right:0" @click="clickguanbi()" />
        <span v-if="showuparrow" class="sinour normal el-icon-arrow-up" />
        <span v-if="showdownarrow" class="sinour normal el-icon-arrow-down" />
        <span v-if="showright" class="sinour normal el-icon-check" style="color: #009688;" />
        <span v-if="showrighttext" class="sinour normal right righttext" :style="{color:righttextcolor,right:showrightarrow?'32px':'16px'}" @click.stop="clickrighttext">{{ righttext }}</span>
        <span v-if="showcount && count>0" class="sinour normal count">{{ count }}</span>
        <wxl-btn v-if="showbtn" ref="btn" class="sinour sinour-btn-content" :type="btntype" size="mini" @click="clickbtn">
            {{ btntext }}
        </wxl-btn>
    </div>
</template>
<script>
    export default {
        name: 'wxl-list-item',
        components: {
            wxlBtn: import('@/components/Sinour/wxl-btn.vue')
        },
        props: {
            type: {
                type: String,
                default: 'text' // text直接显示,object
            },
            item: Object,
            displaykey: {
                type: String,
                default: 'name'
            },
            text: String,
            showrightarrow: {
                type: Boolean,
                default: false
            },
            showuparrow: {
                type: Boolean,
                default: false
            },
            showdownarrow: {
                type: Boolean,
                default: false
            },
            showcount: {
                type: Boolean,
                default: false
            },
            showright: Boolean,
            count: {
                type: Number,
                default: 0
            },
            showbtn: {
                type: Boolean,
                default: false,
            },
            btntext: String,
            btntype: {
                type: String,
                default: 'info'
            },
            textcolor: {
                type: String,
                default: '#333'
            },
            background: {
                type: String,
                default: 'White'
            },
            textalign: {
                type: String,
                default: 'left'
            },
            righttext: [String, Number],
            righttextcolor: {
                type: String,
                default: '#999'
            },
            showrighttext: Boolean,
            showguanbi: Boolean,
            showadd: Boolean,
            showminus: Boolean,
            fontsize: {
                type: [Number, String],
                default: 16
            }
        },
        computed: {
            getText: function() {
                switch (this.type) {
                    case 'text':
                        if (!this.text) {
                            return ''
                        }
                        // 替换 \r\n 为 <br> 标签
                        return this.text.replace(/\r?\n/g, '<br>')
                    case 'object': {
                        if (!this.item[this.displaykey]) {
                            return ''
                        }
                        // 替换 \r\n 为 <br> 标签
                        return this.item[this.displaykey].replace(/\r?\n/g, '<br>')
                    }
                    default:
                        return ''
                }
            }
        },
        methods: {
            clickitem: function() {
                this.$emit('click', this.item)
            },
            clickbtn: function() {
                this.$emit('clickbtn')
            },
            clickrighttext: function() {
                this.$emit('clickrighttext')
            },
            clickguanbi: function() {
                this.$emit('guanbi')
            },
            getcontentstyle: function() {
                return {
                    color: this.textcolor,
                    fontSize: this.fontsize + 'px',
                    'text-align': this.textalign
                }
            }
        },
        mounted: function() {
        },
        watch: {
        }
    }
</script>
<style lang="less" scoped>
    @import '@/styles/color.less';
    @import '@/styles/size.less';
    @sizeunit:16px;
    .wxl-list-item {
        position: relative;
        min-height: @sizeunit*3;
        line-height: @sizeunit*3;
        font-size: @fontsize-big;
        border-bottom: 1px solid @bordercolor;
        width:100%;
        background: white;
        border-radius: 4px;
        user-select: none;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &:active{
            background: @bordercolor;
        }
        .normal{
            color:@normal;
        }
        .sinour {
            position: absolute;
            right: @sizeunit;
            top: 0;
        }

        .count {
            min-width: @sizeunit;
            height: @sizeunit;
            text-align: center;
            line-height: @sizeunit;
            color: @white;
            background-color: @danger;
            border-radius: @sizeunit;
            right: @sizeunit*2;
            margin: @sizeunit 0;
        }
        .sinour-btn-content {
            height: @sizeunit*1.5;
            padding: 2px 4px;
            text-align: center;
            line-height: @sizeunit*1.5;
            border-radius: 4px;
            margin: 12px 4px;
        }
        .text {
            display: inline-block;
            width: calc(100% - @sizeunit*2);
        }
        .text[textalign='center'] {
            text-align: center;
        }
        .righttext {
            font-size: @fontsize-min;
        }
        .add{
            &:before{
                content: "+";
            }
        }
    }
</style>
